import { render, staticRenderFns } from "./chatlist.vue?vue&type=template&id=4b0a899e&scoped=true"
import script from "./chatlist.vue?vue&type=script&lang=js"
export * from "./chatlist.vue?vue&type=script&lang=js"
import style0 from "./chatlist.vue?vue&type=style&index=0&id=4b0a899e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a899e",
  null
  
)

export default component.exports